import { gqTools } from '../index'
import gql from 'graphql-tag'

let q = {}
const queries = require.context('./query/', true, /\.graphql$/)

queries.keys().forEach(key => {
  q[key.replace(/\.(\/|graphql)/g, '')] = queries(key)
})

export class GraphqQlApi {
  // get model by ref
  static async getModuleByIdandVersion(ids) {
    return await callQuery('WebAppModeler', 'getModules', { ids: ids })
  }

  static async getModulesNonEditor(ids) {
    return await callQuery('WebAppModeler', 'getModulesNonEditor', { ids: ids })
  }

  static async onInitApp(args) {
    const response = await callQuery('WebAppModeler', 'onInitApp', args)
    return getHookResult(response.data.webapphooks.onInitApp)
  }

  static async OnBeforePageEnter(args) {
    const response = await callQuery('WebAppModeler', 'onBeforePageEnter', args)
    return getHookResult(response.data.webapphooks.onBeforePageEnter)
  }

  static async onAfterSignIn(args) {
    const response = await callQuery('WebAppModeler', 'onAfterSignIn', args)
    return getHookResult(response.data.webapphooks.onAfterSignIn)
  }
}

async function callQuery(schema, query, args) {
  try {
    const client = await gqTools.getClient(schema)
    return await client.query({
      query: gql`${q[query]}`,
      variables: args
    })
  } catch (e) {
    throw new Error(e.message)
  }
}

function getHookResult(response) {
  return { result: response.result, activities: response.activities.map(x => JSON.parse(x))}
}
